import type { ApiReturnMfe } from '@highimpact-frontend/api-types';
import { useEffect, useState } from 'react';

import { useDashboardHost } from '../../context/DashboardHostContext';
import { keepLatestMfeVersions } from '../mfe/keepLatestMfeVersions';

export type MFEMetaDataState =
  | { status: 'init' }
  | { status: 'loading' }
  | { status: 'error'; details: unknown }
  | { status: 'success'; data: ApiReturnMfe[] };

export default function useMFEMetaData(): MFEMetaDataState {
  const { api } = useDashboardHost();
  const [state, setState] = useState<MFEMetaDataState>({ status: 'init' });

  useEffect(() => {
    if (state.status === 'init') {
      if (sessionStorage.getItem('DO_NOT_RELOAD_WIDGET_DATA') === 'true') {
        setState({ status: 'success', data: [] });
        return;
      }
      setState({ status: 'loading' });
      api.mfe
        .getMfes()
        .then((data) =>
          setState({ status: 'success', data: keepLatestMfeVersions(data) })
        )
        .catch((reason) => setState({ status: 'error', details: reason }));
    }
  }, [api.mfe, state.status]);

  return state;
}

export { keepLatestMfeVersions };
